import React, { useContext } from "react";
import ValidationError from "./ValidationError";
import { FormContext } from "../context/form-context";

const NonFieldErrors = () => {
  const {
    form: { errors = {} }
  } = useContext(FormContext);
  const nonFieldErrors = errors["non_field_errors"] || errors[""];
  if (nonFieldErrors) {
    return (
      <div className="alert alert-danger">
        <ValidationError>{nonFieldErrors}</ValidationError>
      </div>
    );
  } else {
    return null;
  }
};

export default NonFieldErrors;
